module.exports = __webpack_public_path__ + "static/7-3c25f408289244ea8e89d131dd891736.jpg";